import wrapper from 'wrapper';
import Paper from './components/paper/paper';

Paper(wrapper);
const revealButton = wrapper.select('.bbc-news-vj-wrapper .timeline__container .timeline__button--reveal');
if (revealButton) {
    revealButton.addEventListener('click', () => {
        wrapper.trackUserAction('Timeline reveal button clicked');
    });
}
wrapper.markPageAsLoaded();
